// @ts-ignore
import md5 from "js-md5";
// @ts-ignore
import CryptoJS from "crypto-js";
/** 短横线转驼峰 */
export function underlineToHump(str: string) {
  const strList = str.split("-");
  return strList
    .map(item => {
      item = item.slice(0, 1).toUpperCase() + item.slice(1);
      return item;
    })
    .join("");
}

/**
 * 复制到剪切板
 * @param value 值
 */
export function copy(value: string): boolean {
  const text = document.createElement("textarea");
  let result = true;
  try {
    text.value = value;
    document.body.appendChild(text);
    text.select();
    document.execCommand("copy");
  } catch (error) {
    result = false;
  }
  document.body.removeChild(text);
  return result;
}

/**
 * 日期格式化
 *   例如 dateFormat(new Date(), 'YYYY-mm-dd HH:MM')
 *
 * */
export function dateFormat(dateObj: Date, fmt: string) {
  const o: any = {
    "M+": dateObj.getMonth() + 1, //月份
    "d+": dateObj.getDate(), //日
    "h+": dateObj.getHours(), //小时
    "m+": dateObj.getMinutes(), //分
    "s+": dateObj.getSeconds(), //秒
    "q+": Math.floor((dateObj.getMonth() + 3) / 3), //季度
    S: dateObj.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (dateObj.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (const k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}
// 在app内获取区县appid
export function getAppidFromUA() {
  let ua = navigator.userAgent;
  let matchArr = /CQ_XHL\((.+)\)/.exec(ua);
  if (matchArr && matchArr.length) {
    let appinfoArr = matchArr[1].split(";");
    if (appinfoArr.length) {
      return appinfoArr[2];
    } else {
      return "";
    }
  } else {
    return "";
  }
}
